import { render } from "./StreamSidebarPlaybackPlaceholder.vue?vue&type=template&id=46ff2b2a"
import script from "./StreamSidebarPlaybackPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamSidebarPlaybackPlaceholder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamSidebar/StreamSidebarPlaybackPlaceholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46ff2b2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46ff2b2a', __exports__)) {
    api.reload('46ff2b2a', __exports__)
  }
  
  module.hot.accept("./StreamSidebarPlaybackPlaceholder.vue?vue&type=template&id=46ff2b2a", () => {
    api.rerender('46ff2b2a', render)
  })

}


export default __exports__